import { GenericComponent } from '@gorila-shared-ui/components';
import { useSetRecoilState } from 'recoil';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { getNotificationTypes } from '../../../services/reportsService';
import { notificationTypesState } from '../../../storage/reports';
import { ReportTools } from '../../reports/ReportTools';

type Props = Readonly<Omit<GenericComponent, 'classNames'>>;

function ReportsSharedWrapper({ children }: Props) {
  const setNotificationTypes = useSetRecoilState(notificationTypesState);

  useEffectOnce(() => {
    const loadNotificationTypes = async () => {
      const { notificationTypes, error } = await getNotificationTypes();

      if (!error && notificationTypes) {
        setNotificationTypes(notificationTypes);
      }
    };
    loadNotificationTypes();
  });

  return (
    <>
      <ReportTools />
      {children}
    </>
  );
}

export default ReportsSharedWrapper;
